// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/check-orange.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/checkbox-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.More_confirm__T4s\\+S {
  width: 100%;
  border: 2px dashed #4343ff;
  border-radius: 12px;
  padding: 20px;
  color: #00007a;
  line-height: 1.8;
  margin-bottom: 20px;
}
.More_confirm__T4s\\+S > span {
  display: block;
  font-size: 20px;
  font-weight: initial;
  margin-bottom: 10px;
}
.More_confirm__T4s\\+S > p {
  font-weight: 300;
}
.More_confirm__T4s\\+S > p b {
  font-weight: 600;
}

.More_cards__VSCGU {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.More_main__If\\+lp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 12px;
  background: #4343ff;
  color: #fff;
}
.More_main__If\\+lp ul {
  width: 100%;
  padding: 0;
}
.More_main__If\\+lp ul li {
  display: flex;
  font-size: 16px;
  padding: 5px 0;
}
.More_main__If\\+lp ul li::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  transform: translateY(1px);
}
.More_main__If\\+lp div {
  width: 100%;
  text-align: left;
  position: relative;
}

.More_price__4boer {
  font-size: 28px;
  display: block;
}

.More_toggle__607Lv {
  line-height: 17px;
  display: block;
  padding: 5px 0;
  position: absolute;
  bottom: 0;
  right: 0;
}
.More_toggle__607Lv span {
  width: 72px;
  height: 38px;
  line-height: 38px;
  display: inline-block;
  position: relative;
  vertical-align: sub;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.3s;
}
.More_toggle__607Lv span::after {
  content: "";
  width: 28px;
  height: 28px;
  position: absolute;
  background: #f5f5ff;
  top: 5px;
  border-radius: 50%;
  transition: left 0.3s;
}
.More_toggle__607Lv input {
  width: 100%;
  height: 100%;
}
.More_toggle__607Lv input:checked + span {
  background: #FFA92C;
}
.More_toggle__607Lv input:checked + span::after {
  left: calc(100% - 33px);
}
.More_toggle__607Lv input:not(:checked) + span {
  background: #D8D8FF;
}
.More_toggle__607Lv input:not(:checked) + span::after {
  left: 5px;
}

.More_product__mGTWr {
  padding: 20px;
  border-radius: 12px;
  background: #fff;
  color: #00007a;
}
.More_product-title__A85xk {
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.More_product-description__LlbAk {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
}

.More_logo__m9vwI {
  margin-right: 8px;
}

.More_collapsible-card__PNKif {
  padding: 20px;
  background: #fff;
}

.More_list__OwnR\\+ {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  padding: 0;
}
.More_list-title__uKomE {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.More_item__NJITo {
  display: flex;
  align-items: baseline;
}
.More_item__NJITo:before {
  content: "";
  display: inline-block;
  width: 17px;
  min-width: 17px;
  height: 17px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  vertical-align: top;
  transform: translateY(4px);
}

.More_button__TiXXx {
  width: 220px;
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/More/More.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAIA;EACE,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,cCFS;EDGT,gBAAA;EACA,mBAAA;AAGF;AADE;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAGJ;AADE;EACE,gBAAA;AAGJ;AADI;EACE,gBAAA;AAGN;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBCvCS;EDwCT,WAAA;AACF;AACE;EACE,WAAA;EACA,UAAA;AACJ;AACI;EACE,aAAA;EACA,eAAA;EACA,cAAA;AACN;AACM;EACE,gDAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AACR;AAIE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;;AAOA;EACE,eAAA;EACA,cAAA;AAJF;;AAUA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AAPJ;AASI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBCxGK;EDyGL,QAAA;EACA,kBAAA;EACA,qBAAA;AAPN;AAWE;EACE,WAAA;EACA,YAAA;AATJ;AAWI;EACE,mBAAA;AATN;AAUM;EACE,uBAAA;AARR;AAYI;EACE,mBAAA;AAVN;AAWM;EACE,SAAA;AATR;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cCnIS;ADoHX;AAiBE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAhBJ;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCzKO;ADwJX;;AAqBA;EACE,aAAA;EACA,qBAAA;AAlBF;AAoBE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAlBJ;;AAsBA;EACE,YAAA;AAnBF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n\n.confirm{\n  width: 100%;\n  border: 2px dashed colors.$primary4;\n  border-radius: 12px;\n  padding: 20px;\n  color: colors.$primary8;\n  line-height: 1.8;\n  margin-bottom: 20px;\n\n  > span {\n    display: block;\n    font-size: 20px;\n    font-weight: initial;\n    margin-bottom: 10px;\n  }\n  > p{\n    font-weight: 300;\n\n    b{\n      font-weight: 600;\n    }\n  }\n}\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  border-radius: 12px;\n  background: colors.$primary4;\n  color: #fff;\n\n  ul{\n    width: 100%;\n    padding: 0;\n\n    li{\n      display: flex;\n      font-size: 16px;\n      padding: 5px 0;\n  \n      &::before{\n        content: url(../../../assets/check-orange.svg);\n        display: inline-block;\n        margin-right: 10px;\n        vertical-align: middle;\n        transform: translateY(1px);\n      }\n    }\n  }\n\n  div{\n    width: 100%;\n    text-align: left;\n    position: relative;\n  }\n}\n\n\n.price{\n  font-size: 28px;\n  display: block;\n}\n\n\n// Toggle\n\n.toggle{\n  line-height: 17px;\n  display: block;\n  padding: 5px 0;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n\n  span{\n    width: 72px;\n    height: 38px;\n    line-height: 38px;\n    display: inline-block;\n    position: relative;\n    vertical-align: sub;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: background 0.3s;\n\n    &::after{\n      content: \"\";\n      width: 28px;\n      height: 28px;\n      position: absolute;\n      background: colors.$primary1;\n      top: 5px;\n      border-radius: 50%;\n      transition: left 0.3s;\n    }\n  }\n\n  input{\n    width: 100%;\n    height: 100%;\n    \n    &:checked + span{\n      background: #FFA92C;\n      &::after{\n        left: calc(100% - 33px);\n      }\n    }\n    \n    &:not(:checked) + span{\n      background: #D8D8FF;\n      &::after{\n        left: 5px;\n      }\n    }\n  }\n}\n\n\n\n\n.product {\n  padding: 20px;\n  border-radius: 12px;\n  background: #fff;\n  color: colors.$primary8;\n\n  &-title {\n    margin-bottom: 12px;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  &-description {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n  }\n}\n\n.logo {\n  margin-right: 8px;\n}\n\n.collapsible-card {\n  padding: 20px;\n  background: #fff;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  padding: 0;\n\n  &-title {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: baseline;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    background: url(../../../assets/checkbox-circle.svg);\n    background-size: cover;\n    vertical-align: top;\n    transform: translateY(4px);\n  }\n}\n\n.button{\n  width: 220px;\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"confirm": `More_confirm__T4s+S`,
	"cards": `More_cards__VSCGU`,
	"main": `More_main__If+lp`,
	"price": `More_price__4boer`,
	"toggle": `More_toggle__607Lv`,
	"product": `More_product__mGTWr`,
	"product-title": `More_product-title__A85xk`,
	"product-description": `More_product-description__LlbAk`,
	"logo": `More_logo__m9vwI`,
	"collapsible-card": `More_collapsible-card__PNKif`,
	"list": `More_list__OwnR+`,
	"list-title": `More_list-title__uKomE`,
	"item": `More_item__NJITo`,
	"button": `More_button__TiXXx`
};
export default ___CSS_LOADER_EXPORT___;
